import { Component, ElementRef, OnDestroy, OnInit, Optional, Renderer2, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PanelOptionsClass, TRANSITION_DURATIONS } from '@app/shared/panels/services/option.class';
import { EmailModalService } from '@app/shared/panels/services/email-modal.service';

/** Gmail-style floating compose shell (Figma "Record popup/Email widget") — fixed bottom-right, no backdrop. */
@Component({
  selector: 'cs-email-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './email-modal-render.html',
  styleUrl: './email-modal-render.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'cs-email-modal-v2 cs-common-cs-lock',
    role: 'dialog',
    tabindex: '-1',
    '[attr.aria-modal]': 'false',
    '[attr.aria-labelledby]': 'config.ariaLabelledBy',
  },
})
export class EmailModalRender implements OnInit, OnDestroy {
  config!: PanelOptionsClass;

  isShown = false;
  level?: number;
  isAnimated = false;
  private isModalHiding = false;

  constructor(
    protected _element: ElementRef,
    private _renderer: Renderer2,
    @Optional() private emailModalService?: EmailModalService,
  ) {
  }

  ngOnInit(): void {
    if (!this.config) {
      this.config = { id: 'default-email-modal' };
    }

    if (this.isAnimated) {
      this._renderer.addClass(this._element.nativeElement, 'cs-fade');
    }
    this._renderer.setStyle(this._element.nativeElement, 'display', 'block');

    setTimeout(() => {
      this.isShown = true;
      this._renderer.addClass(this._element.nativeElement, 'cs-show');
    }, this.isAnimated ? TRANSITION_DURATIONS.BACKDROP : 0);

    if (this._element.nativeElement) {
      this._element.nativeElement.focus();
    }
  }

  hide(): void {
    if (this.isModalHiding) {
      return;
    }
    this._hide();
  }

  protected _hide(): void {
    this.isModalHiding = true;
    this._renderer.removeClass(this._element.nativeElement, 'cs-show');
    setTimeout(() => {
      this.isShown = false;
      this.emailModalService?.hide(this.config.id);
      this.isModalHiding = false;
    }, this.isAnimated ? TRANSITION_DURATIONS.MODAL : 0);
  }

  ngOnDestroy(): void {
    if (this.isShown) {
      this._hide();
    }
  }
}
